import type { FaireProductEntity } from "../../entity_types/product";

export const p_5b37tzyzqa: FaireProductEntity = {
  token: "p_5b37tzyzqa",
  type: "product",
  name: "Honey Pot Basket: Akazi",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/3ac9382381db4676cc2e33aafd883486cb46ec4507f515c5c981f71b0b8b5ae6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8a436f375a223bdb1683b6a4dd6d27a76f6f7feffb81657de5a83fccb10a3a0.jpeg",
    "https://cdn.faire.com/fastly/777065818e5c7da9291e2549c6d8479f4f0168b332ac489ce74902738f0487f7.jpeg",
    "https://cdn.faire.com/fastly/77d9ecaf5935bb0aa17102a9ce5a3afa6017ae318120cb16388851f66dc5e1f3.jpeg"
  ],
  priceDollars: 34,
  description: "These woven basket planters are handmade by our artisans in Gitarama, Rwanda. The women hand-dye and weave the fibers into these beautiful works of art. The sisal is woven around sweetgrass, a fragrant grass with a subtle sweetness. Use these African baskets as a desk accessory, a plant holder, or to brighten up a shelf! Plant not included.\n\nSmall: 8\" x 6\"\nLarge: 10\" x 8\"",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:19.209Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
